<template>
  <div ref="container">
    <a-modal
      :title="materialName + ' 的选项设置'"
      :width="880"
      :visible="visible"
      :footer="null"
      :getContainer="() => $refs.container"
      :mask="isDesktop()"
      :maskClosable="false"
      @cancel="handleCancel"
      style="top: 60px;">
      <a-spin :spinning="loading">
        <!-- 选项组表单（新建/编辑） -->
        <div class="group-form-card">
          <div class="group-form-title">{{ groupForm.id ? '编辑选项组' : '新建选项组' }}</div>
          <a-form layout="inline">
            <a-form-item label="组名称">
              <a-input placeholder="如：规格/加料/做法" v-model="groupForm.name" style="width: 180px" allow-clear />
            </a-form-item>
            <a-form-item label="类型">
              <a-select v-model="groupForm.type" style="width: 140px">
                <a-select-option value="SINGLE">规格(单选)</a-select-option>
                <a-select-option value="EXTRA">加料(多选)</a-select-option>
                <a-select-option value="PRACTICE">做法(单选)</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="必选">
              <a-switch :checked="groupForm.required" @click="() => groupForm.required = !groupForm.required" />
            </a-form-item>
            <a-form-item label="排序">
              <a-input-number :min="0" :precision="0" v-model="groupForm.sort" style="width: 90px" />
            </a-form-item>
            <a-form-item>
              <a-button type="primary" :loading="saving" @click="submitGroup">
                {{ groupForm.id ? '保存修改' : '新建组' }}
              </a-button>
              <a-button v-if="groupForm.id" style="margin-left: 8px" @click="resetGroupForm">取消编辑</a-button>
            </a-form-item>
          </a-form>
        </div>
        <!-- 选项组列表 -->
        <div v-if="groups.length === 0" style="color: #999; padding: 24px 0; text-align: center;">
          暂无选项组，请先新建
        </div>
        <div v-for="group in groups" :key="group.id" class="group-card">
          <div class="group-header">
            <span class="group-name">{{ group.name }}</span>
            <a-tag :color="typeMeta[group.type] ? typeMeta[group.type].color : ''">
              {{ typeMeta[group.type] ? typeMeta[group.type].label : group.type }}
            </a-tag>
            <a-tag :color="group.required === '1' ? 'red' : ''">{{ group.required === '1' ? '必选' : '可选' }}</a-tag>
            <span class="group-sort">排序 {{ group.sort }}</span>
            <span class="group-ops">
              <a @click="editGroup(group)">编辑组</a>
              <a-divider type="vertical" />
              <a style="color: red" @click="removeGroup(group)">删除组</a>
              <a-divider type="vertical" />
              <a @click="addValue(group)">添加值</a>
            </span>
          </div>
          <a-table
            size="small"
            bordered
            :pagination="false"
            rowKey="id"
            :columns="valueColumns"
            :dataSource="group.values">
            <template slot="priceSlot" slot-scope="text">
              <span v-if="text !== null && text !== undefined && Number(text) > 0">+{{ text }}</span>
              <span v-else>-</span>
            </template>
            <span slot="valueAction" slot-scope="text, record">
              <a @click="editValue(group, record)">编辑</a>
              <a-divider type="vertical" />
              <a style="color: red" @click="removeValue(record)">删除</a>
            </span>
          </a-table>
        </div>
      </a-spin>
      <!-- 选项值编辑小弹窗 -->
      <a-modal
        :title="valueForm.id ? '编辑选项值' : '添加选项值'"
        :visible="valueVisible"
        :confirmLoading="valueSaving"
        :getContainer="() => $refs.container"
        :mask="false"
        :maskClosable="false"
        @ok="submitValue"
        @cancel="valueVisible = false"
        cancelText="取消"
        okText="保存"
        style="top: 200px;">
        <a-form>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="值名称">
            <a-input placeholder="如：大份/加冰/微辣" v-model="valueForm.name" allow-clear />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加价">
            <a-input-number :min="0" :precision="2" v-model="valueForm.addPrice" style="width: 100%" placeholder="选该值时加收金额" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
            <a-input-number :min="0" :precision="0" v-model="valueForm.sort" style="width: 100%" />
          </a-form-item>
        </a-form>
      </a-modal>
    </a-modal>
  </div>
</template>
<script>
import { optionGroups, optionGroupAdd, optionGroupUpdate, optionGroupDelete,
  optionValueAdd, optionValueUpdate, optionValueDelete } from '@/api/plugin/dining'
import { mixinDevice } from '@/utils/mixin'

/**
 * 选项设置弹窗（Task 9）：选项组（SINGLE=规格/EXTRA=加料/PRACTICE=做法）与组内值的增删改
 * 打开传 record：{id: goodsId, materialName}
 */
export default {
  name: 'OptionGroupsModal',
  mixins: [mixinDevice],
  data() {
    return {
      visible: false,
      loading: false,
      saving: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      goodsId: null,
      materialName: '',
      groups: [],
      typeMeta: {
        SINGLE: { label: '规格(单选)', color: 'blue' },
        EXTRA: { label: '加料(多选)', color: 'purple' },
        PRACTICE: { label: '做法(单选)', color: 'cyan' }
      },
      groupForm: { id: null, name: '', type: 'SINGLE', required: false, sort: 0 },
      valueColumns: [
        { title: '值名', dataIndex: 'name', align: 'left' },
        { title: '加价', dataIndex: 'addPrice', width: 100, align: 'right', scopedSlots: { customRender: 'priceSlot' } },
        { title: '排序', dataIndex: 'sort', width: 80, align: 'center' },
        { title: '操作', dataIndex: 'action', width: 120, align: 'center', scopedSlots: { customRender: 'valueAction' } }
      ],
      valueVisible: false,
      valueSaving: false,
      valueForm: { groupId: null, id: null, name: '', addPrice: 0, sort: 0 }
    }
  },
  methods: {
    open(record) {
      this.goodsId = record.id
      this.materialName = record.materialName || ''
      this.visible = true
      this.resetGroupForm()
      this.loadGroups()
    },
    loadGroups() {
      this.loading = true
      optionGroups(this.goodsId).then((res) => {
        if (res.code === 200) {
          this.groups = res.data || []
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    resetGroupForm() {
      this.groupForm = { id: null, name: '', type: 'SINGLE', required: false, sort: 0 }
    },
    editGroup(group) {
      this.groupForm = {
        id: group.id,
        name: group.name,
        type: group.type,
        required: group.required === '1',
        sort: group.sort
      }
    },
    submitGroup() {
      const form = this.groupForm
      if (!form.name || !form.name.trim()) {
        this.$message.warning('请输入选项组名称')
        return
      }
      const body = {
        name: form.name.trim(),
        type: form.type,
        required: form.required ? '1' : '0',
        sort: form.sort === null || form.sort === undefined ? 0 : form.sort
      }
      this.saving = true
      const req = form.id ? optionGroupUpdate(form.id, body) : optionGroupAdd(Object.assign({ goodsId: this.goodsId }, body))
      req.then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.resetGroupForm()
          this.loadGroups()
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.saving = false
      })
    },
    removeGroup(group) {
      this.$confirm({
        title: '删除选项组',
        content: '确定删除选项组 "' + group.name + '" 吗？组下全部选项值将一并删除。',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          return optionGroupDelete(group.id).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              this.loadGroups()
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      }).catch(() => {})
    },
    addValue(group) {
      this.valueForm = { groupId: group.id, id: null, name: '', addPrice: 0, sort: 0 }
      this.valueVisible = true
    },
    editValue(group, record) {
      this.valueForm = {
        groupId: group.id,
        id: record.id,
        name: record.name,
        addPrice: record.addPrice === null || record.addPrice === undefined ? 0 : Number(record.addPrice),
        sort: record.sort
      }
      this.valueVisible = true
    },
    submitValue() {
      const form = this.valueForm
      if (!form.name || !form.name.trim()) {
        this.$message.warning('请输入选项值名称')
        return
      }
      const body = {
        name: form.name.trim(),
        addPrice: form.addPrice === null || form.addPrice === undefined ? 0 : form.addPrice,
        sort: form.sort === null || form.sort === undefined ? 0 : form.sort
      }
      this.valueSaving = true
      const req = form.id ? optionValueUpdate(form.id, body) : optionValueAdd(form.groupId, body)
      req.then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.valueVisible = false
          this.loadGroups()
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.valueSaving = false
      })
    },
    removeValue(record) {
      this.$confirm({
        title: '删除选项值',
        content: '确定删除选项值 "' + record.name + '" 吗？',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          return optionValueDelete(record.id).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              this.loadGroups()
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      }).catch(() => {})
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped>
.group-form-card { border: 1px dashed #d9d9d9; border-radius: 4px; padding: 12px 16px 0; margin-bottom: 16px; background: #fafafa; }
.group-form-title { font-weight: bold; margin-bottom: 8px; }
.group-card { border: 1px solid #e8e8e8; border-radius: 4px; padding: 12px 16px; margin-bottom: 16px; }
.group-header { margin-bottom: 8px; }
.group-name { font-weight: bold; margin-right: 8px; }
.group-sort { color: #999; margin-left: 8px; font-size: 12px; }
.group-ops { float: right; }
</style>
